const doc = [({"en":({"js":({"admin":({"users":({"passwords":({"new":({"forgot_your_password":"Forgot your password?"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;